import { ColumnSort, SortBy } from './PipelineContext'

const COLUMN_SORT_PAIRS: Record<string, [SortBy, SortBy]> = {
  title: ['name_asc', 'name_desc'],
  step: ['phase', 'phase_desc'],
  deadline: ['deadline', 'deadline_desc'],
  tags: ['tags_asc', 'tags_desc'],
  details: ['details_asc', 'details_desc'],
}

export function getNextColumnSort(columnId: string, current: ColumnSort | null): ColumnSort {
  if (current?.id === columnId) {
    return { id: columnId, desc: !current.desc }
  }
  return { id: columnId, desc: false }
}

export function columnSortToSortBy(columnSort: ColumnSort): SortBy {
  const pair = COLUMN_SORT_PAIRS[columnSort.id]
  if (!pair) return 'phase'
  return columnSort.desc ? pair[1] : pair[0]
}

export function resolveActiveSortBy(sortBy: SortBy | '', columnSort: ColumnSort | null): SortBy {
  if (columnSort) return columnSortToSortBy(columnSort)
  return sortBy || 'phase'
}
